import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { ActivityStatsMonthWisePieChart } from "app/components/dashboards/ActivityStatsMonthWisePieChart";
import { ActivityStatsMonthAndMemberWiseBarChart } from "app/components/dashboards/ActivityStatsMonthAndMemberWiseBarChart";
import { getDateInDDMMYYYYFormat } from "utils/dateUtil";

export const ActivityStatsChartsRow = ({ activityStatsData, fromDate, toDate }) => {
  const periodLabel = `${getDateInDDMMYYYYFormat(fromDate)} and ${getDateInDDMMYYYYFormat(toDate)}`;

  return (
    <Grid container spacing={6} p={1}>
      <Grid size={4}>
        <ActivityStatsMonthWisePieChart
          activityStatsData={activityStatsData}
          title={`Month-wise efforts between ${periodLabel}`}
        />
      </Grid>
      <Grid size={8}>
        <ActivityStatsMonthAndMemberWiseBarChart
          activityStatsData={activityStatsData}
          title={`Month-wise and Member-wise efforts between ${periodLabel}`}
        />
      </Grid>
    </Grid>
  );
};

const dateProp = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.instanceOf(Date),
  PropTypes.object,
]);

ActivityStatsChartsRow.propTypes = {
  activityStatsData: PropTypes.array.isRequired,
  fromDate: dateProp.isRequired,
  toDate: dateProp.isRequired,
};
